import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"

export default class extends Controller {

  static targets = [ "entry" ]

  initialize(){
    Loggable(this, {debug: true})
    this.log("initialized")
  }
  connect(){
    this.hideCounterparts()
    this.log("connected")
  }

  hideCounterparts(){
    this.entryTargets.forEach((e) => {
      if ( e.dataset.counterpartId && e.dataset.postType=="InPersonLive" ) {
        this.log(e.dataset.postId+" has counterpart")
        if(this.counterpartFor(e)){
          this.log("hiding")
          this.setHybridCssClass(e)
          this.movePlayer(this.counterpartFor(e),e)
          this.removeNoise(e)
          this.hideCounterpart(e)
        } else {
          this.log("counterpart not found")
        }
      }
    })
  }

  setHybridCssClass(entry){
    entry.classList.remove("InPersonLive")
    entry.classList.remove("Live")
    entry.classList.add("Hybrid")
  }

  showHybridLabel(entry){
    let label =  entry.getElementsByClassName("entry--label")[0]
    if(label){
      label.innerHTML = this.data.get("hybridLabel")
    }
  }

  hideCounterpart(entry){
    this.counterpartFor(entry).remove()
  }

  movePlayer(source_entry,target_entry){
    let sources_player = source_entry.getElementsByClassName("entry--player")[0]
    let targets_player = target_entry.getElementsByClassName("entry--player")[0]

    $(sources_player).insertAfter(targets_player)
  }

  // para evitar ruido no muestro botón bloqueado si ya hay otro botón.
  // si hay 2 botones bloqueados dejo el de reserva.
  removeNoise(entry) {
    const buttons = Array.from(entry.getElementsByClassName("btn"));
    const levelUpBadges = Array.from(entry.getElementsByClassName("level-up-badge"));

    if (buttons.length > 1) {
      buttons.filter((b) => { return b.parentNode.dataset.hybridInfo === 'blocked-enter-live' }).forEach((b) => {
        b.remove();
      });
    }
    if (levelUpBadges.length > 1) {
      levelUpBadges[0].remove();
    }
  }

  counterpartFor(entry){
    return this.entryTargets.filter((e)=>{ return e.dataset.postId==entry.dataset.counterpartId && e.dataset.wday==entry.dataset.wday })[0]
  }
}
